import { useEffect, useRef } from "react";

const FIRED_KEY = "conduit_exit_intent_fired";

/**
 * Fires a callback when the user's mouse leaves the viewport (desktop only).
 * Only fires once per session. Skips if the user has already submitted the waitlist.
 */
export function useExitIntent(onExit: () => void) {
  const firedRef = useRef(false);

  useEffect(() => {
    if (sessionStorage.getItem(FIRED_KEY) === "1") return;
    if (localStorage.getItem("conduit_waitlist")) {
      const entries = JSON.parse(localStorage.getItem("conduit_waitlist") || "[]");
      if (entries.length > 0) return;
    }

    function handleMouseLeave(e: MouseEvent) {
      if (e.clientY > 0) return;
      if (firedRef.current) return;
      firedRef.current = true;
      sessionStorage.setItem(FIRED_KEY, "1");
      onExit();
    }

    document.documentElement.addEventListener("mouseleave", handleMouseLeave);
    return () => document.documentElement.removeEventListener("mouseleave", handleMouseLeave);
  }, [onExit]);
}
